// Auto-generated skeleton for ReviewDocument

import { Building } from './Building'
import { AccountingYear } from './AccountingYear'
import { Team } from './Team'
import { DocumentContainer } from './DocumentContainer'
import { Account } from './Account'
import { ReviewDocumentReviewer } from './ReviewDocumentReviewer'
import { Comment } from './Comment'

export const ReviewDocument: Api.ReviewDocument = {
	id: 0,
	hp_id: null,
	building_id: 0,
	team_id: 0,
	accounting_year_id: 0,
	name: null,
	description: null,
	active: false,
	deadline: null,
	completed: null,
	send_reminder: null,
	status: 'pending',
	building: Building,
	accounting_year: AccountingYear,
	team: Team,
	protocol: DocumentContainer,
	documents_count: 0,
	accounts_count: 0,
	reviewers_count: 0,
	accounts: [Account],
	reviewers: [ReviewDocumentReviewer],
	documents: [DocumentContainer],
	comments: [Comment],
	created: null,
	updated: null,
}
